module.exports = __webpack_public_path__ + "static/media/facebook-footer.61c5534f.svg";